import { createFileRoute, useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { GitHubPage } from "../components/github/GitHubPage";
import { ToWorkspaces } from "../components/workspaces/ToWorkspaces";
import { ApiError } from "../lib/api";
import { workspaceSlug } from "../lib/hosts";
import { useWorkspace } from "../lib/workspaces";
import { AdministratorsOnly } from "../components/ui/states";
import { strings } from "../lib/strings";

/** How connecting went, as GitHub's return to Steer said it. */
const githubSearchSchema = z.object({ github: z.string().max(40).optional().catch(undefined) });

/** GitHub (BUILD_SPEC §18.3), for the workspace's Administrators. */
function GitHubRoute() {
  const view = useWorkspace(workspaceSlug());
  const search = useSearch({ from: "/admin/settings/github" });
  if (view.isLoading) return null;
  if (view.error instanceof ApiError || !view.data) return <ToWorkspaces />;
  if (view.data.role !== "administrator") return <AdministratorsOnly what={strings.states.adminPages.github} />;
  return <GitHubPage outcome={search.github} />;
}

export const Route = createFileRoute("/admin/settings/github")({
  validateSearch: githubSearchSchema,
  component: GitHubRoute,
});
